/* Common Imports */

import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

/* Component Imports */

import { Typography, useMediaQuery } from "@material-ui/core";
import Testimonial from "./sub-components/Testimonial";
import Carousel from "@beegru/react-material-ui-carousel";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    margin: "5rem 0rem 5rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "5rem 0rem 0rem 0rem",
    },
    [theme.breakpoints.only("md")]: {
      margin: "5rem 0rem 3rem 0rem",
    },
  },
  sectionTitle: {
    margin: "0rem 0rem 1.5rem 0rem",
    fontWeight: 400,
    fontSize: "2.125rem",
    lineHeight: "3.1875rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.5rem",
      lineHeight: "1.75rem",
      letterSpacing: "0.031rem",
      fontWeight: 500,
    },
  },
  testimonialContainerStyling: {
    width: "100%",
  },
  carouselContainer: {
    height: "18.375rem",
    [theme.breakpoints.only("sm")]: {
      height: "23.5rem",
    },
    [theme.breakpoints.only("md")]: {
      height: "24rem",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: "2rem",
      height: "21rem",
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
}));

const TestimonialCarousel = () => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <React.Fragment>
      <div id="testimonials" className={classes.sectionContainer}>
        <Typography
          variant="body2"
          component="span"
          className={classes.sectionTitle}
        >
          What clients say about us
        </Typography>
        <div className={classes.carouselContainer}>
          <Carousel
            navButtonsProps={{
              style: {
                background: "-webkit-linear-gradient(0deg, #F74134, #EB1C61)",
                boxShadow:
                  "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
              },
            }}
            containerStyling={classes.testimonialContainerStyling}
            animation="slide"
            navButtonsAlwaysVisible={useMediaQuery(theme.breakpoints.up("sm"))}
            navButtonsAlwaysInvisible={useMediaQuery(
              theme.breakpoints.down("xs"),
            )}
            autoPlay={useMediaQuery(theme.breakpoints.up("sm"))}
            interval={15000}
          >
            <Testimonial
              title="Dr. Khoja MB"
              subTitle="I'm very very happy with the way they are functioning and the way they are organized. They are very honest and very very straight forward which is the basic thing. They have very good team work and have been very honest and down to earth."
              thumbnailLink="/images/icons/testimonials/dr-khoja.webp"
              youtubeLink="https://www.youtube.com/embed/VZ_N-Z8AgsU"
            />
            <Testimonial
              title="Saranya &amp; Govindh"
              subTitle="Starting from the booking to the registration regardless of any number of queries, we were able to reach out to them."
              thumbnailLink="/images/icons/testimonials/saranya-and-govindh.webp"
              youtubeLink="https://www.youtube.com/embed/Caj1Ak_sV_4"
            />
            <Testimonial
              title="Muna Guptha"
              subTitle="The experience has been outstanding. They have been taking care of everything. Whatever has been promised has been delivered."
              thumbnailLink="/images/icons/testimonials/muna-guptha.webp"
              youtubeLink="https://www.youtube.com/embed/YnvS8uHE_cY"
            />
            <Testimonial
              title="Mr. and Mrs. Krishnan"
              subTitle="Right from the beginning, from the time we saw the flat, till the entire transaction got complete, we have been very very happy and very very satisfied with the entire process."
              thumbnailLink="/images/icons/testimonials/krishnan.webp"
              youtubeLink="https://www.youtube.com/embed/YIGG7lUggwM"
            />
            <Testimonial
              title="Koushik"
              subTitle="Lighter Advisory team is transparent, friendly and helped with the entire process of buying and registering the property."
              thumbnailLink="/images/icons/testimonials/koushik.webp"
              youtubeLink="https://www.youtube.com/embed/k0CRwixCRlE"
            />
          </Carousel>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TestimonialCarousel;
